export class RewardCategoryModel {
  id: Number;
  category_name: String;
  description: String;
  hassubcategories: Number;
  category_order: Number;
  imagepath: String;
  program_id: Number;
}

export class RewardSubCategoryModel {
  id: Number;
  sub_category_name: String;
  category_name: String;
  description: String;
  category_id: Number;
  imagepath: String;
  program_id: Number;
}

export class RewardTypeModel{
  id: Number;
  status: Number;
  reward_type_icon: String;
  reward_type_name: String;
}